import { render, staticRenderFns } from "./MorePopover.vue?vue&type=template&id=27847a0e&scoped=true"
import script from "./MorePopover.vue?vue&type=script&lang=js"
export * from "./MorePopover.vue?vue&type=script&lang=js"
import style0 from "./MorePopover.vue?vue&type=style&index=0&id=27847a0e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27847a0e",
  null
  
)

export default component.exports